import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["currentPage", "totalPages", "onPrev", "onNext", "onPageChange", "isDark", "dark", "isWhite", "white", "displayPosition", "className", "htmlProps"];
import { forwardRef } from 'react';
import cn from 'classnames';
import IconButton from "../../Buttons/IconButton";
import Dropdown from "../../Dropdown";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Default = function Default(_ref, ref) {
  var _ref$currentPage = _ref.currentPage,
    currentPage = _ref$currentPage === void 0 ? 1 : _ref$currentPage,
    _ref$totalPages = _ref.totalPages,
    totalPages = _ref$totalPages === void 0 ? 1 : _ref$totalPages,
    onPrev = _ref.onPrev,
    onNext = _ref.onNext,
    onPageChange = _ref.onPageChange,
    isDark = _ref.isDark,
    dark = _ref.dark,
    isWhite = _ref.isWhite,
    white = _ref.white,
    _ref$displayPosition = _ref.displayPosition,
    displayPosition = _ref$displayPosition === void 0 ? 'responsive' : _ref$displayPosition,
    className = _ref.className,
    htmlProps = _ref.htmlProps,
    defaultPaginationProps = _objectWithoutProperties(_ref, _excluded);
  var onSelected = function onSelected(selected) {
    if (typeof onPageChange === 'function') {
      onPageChange((selected === null || selected === void 0 ? void 0 : selected.value) || 1);
    }
  };
  var labelClassNames = cn('font-body3 text-nowrap', isDark || dark ? 'text-base-lighter' : 'text-gray-dark');
  return /*#__PURE__*/_jsxs("div", _objectSpread(_objectSpread(_objectSpread({
    ref: ref,
    className: cn('w-full sm:w-auto flex items-center justify-center sm:justify-start', className)
  }, defaultPaginationProps), htmlProps), {}, {
    children: [/*#__PURE__*/_jsx(IconButton, {
      arrow: "left",
      isDark: isDark || dark,
      isWhite: isWhite || white,
      disabled: currentPage <= 1,
      onClick: onPrev
    }), /*#__PURE__*/_jsxs("p", {
      className: cn(labelClassNames, 'ml-8 mr-8 sm:ml-32 sm:mr-24'),
      children: [/*#__PURE__*/_jsx("span", {
        className: "sm:hidden",
        children: defaultPaginationProps.paginationLabel || 'Pág'
      }), /*#__PURE__*/_jsx("span", {
        className: "hidden sm:inline",
        children: defaultPaginationProps.paginationLabel || 'Página'
      })]
    }), /*#__PURE__*/_jsx(Dropdown, {
      className: "w-72 sm:w-80",
      options: Array.from({
        length: totalPages
      }).map(function (_, i) {
        return {
          value: i + 1,
          label: (i + 1).toString()
        };
      }),
      onSelected: onSelected,
      selected: {
        value: currentPage,
        label: currentPage.toString()
      },
      required: true,
      isDark: isDark,
      displayPosition: displayPosition,
      clampText: false
    }), /*#__PURE__*/_jsx("span", {
      className: cn(labelClassNames, 'ml-8 mr-8 sm:ml-24 sm:mr-32'),
      children: "de ".concat(totalPages)
    }), /*#__PURE__*/_jsx(IconButton, {
      arrow: "right",
      isDark: isDark || dark,
      isWhite: isWhite || white,
      disabled: currentPage >= totalPages,
      onClick: onNext
    })]
  }));
};
export default /*#__PURE__*/forwardRef(Default);